import React, { useState } from 'react';
import myClasses from '../SmartCharging.module.css';
import classes from '../../DemandResponse/DemandResponse.module.css';
import Typography from '../../../components/Typography/Typography';
import Table from '../../../components/Table/Table';
import { findDiffInSeconds, momentTimeFormater } from '../../../utils/dateHelper';
import _ from 'lodash';

const ProfileModal = ({ setOpen, data = {} }) => {
    const [schedule, setSchedule] = useState([]);

    useState(() => {
        if (_.get(data, ['chargingProfile', 'charging_profile_period'])) {
            const periods = _.get(data, ['chargingProfile', 'charging_profile_period'], []);
            const processedData = periods.map((item, index) => {
                const start = _.get(data, ['chargingProfile', 'start_date_time'])
                    ? momentTimeFormater(_.get(data, ['chargingProfile', 'start_date_time'])).add(item.start_period, 'seconds')
                    : '--';
                const end = _.get(data, ['chargingProfile', 'start_date_time'])
                    ? momentTimeFormater(_.get(data, ['chargingProfile', 'start_date_time'])).add(
                          _.get(periods, [index + 1, 'start_period']) ? _.get(periods, [index + 1, 'start_period']) : _.get(data, ['chargingProfile', 'duration']),
                          'seconds'
                      )
                    : '--';

                let duration = '--';

                if (start !== '--' && end !== '--') {
                    duration = findDiffInSeconds(start.clone(), end.clone());
                }

                return {
                    start_period: item.start_period,
                    limit: item.limit,
                    start: start.format('YYYY-MM-DD HH:mm:ss'),
                    duration,
                };
            });

            setSchedule(processedData);
        }
    }, []);

    return (
        <div style={{ minWidth: '50vw', maxHeight: '80vh', overflowY: 'scroll' }}>
            <div className={myClasses.HeadingContainer}>
                <Typography content={`Charging Profile Details`} />
            </div>
            {/* <Table
                head={['PROFILE SENT AT (CET)', 'CPO STATUS', 'CHARGER STATUS', 'PROFILE CREATION SOC (%)', 'ACTION']}
                keys={['timestamp', 'cpoStatus', 'chargerStatus', 'soc', 'action']}
                data={tableData}
            /> */}
            <Table
                head={['Label', 'Value']}
                keys={['label', 'value']}
                data={[
                    {
                        label: 'Session ID',
                        value: _.get(data, ['sessionId']),
                    },
                    {
                        label: 'Profile Sent At (CET)',
                        value: data.createdAt ? momentTimeFormater(data.createdAt).format('YYYY-MM-DD HH:mm:ss') : '--',
                    },
                    {
                        label: 'Profile Start (CET)',
                        value: _.get(data, ['chargingProfile', 'start_date_time'])
                            ? momentTimeFormater(_.get(data, ['chargingProfile', 'start_date_time'])).format('YYYY-MM-DD HH:mm:ss')
                            : '--',
                    },
                    {
                        label: 'Profile End (CET)',
                        value: _.get(data, ['chargingProfile', 'start_date_time'])
                            ? momentTimeFormater(_.get(data, ['chargingProfile', 'start_date_time']))
                                  .add(_.get(data, ['chargingProfile', 'duration']), 'seconds')
                                  .format('YYYY-MM-DD HH:mm:ss')
                            : '--',
                    },
                    {
                        label: 'Duration (SEC)',
                        value: _.get(data, ['chargingProfile', 'duration']),
                    },
                    {
                        label: 'Charging Rate Unit',
                        value: _.get(data, ['chargingProfile', 'charging_rate_unit']),
                    },
                    {
                        label: 'Min Charging Rate',
                        value: _.get(data, ['chargingProfile', 'min_charging_rate'], '--'),
                    },
                ]}
            />
            <Typography content={`Charging Profile Schedule`} />
            <Table head={['Start (CET)', 'Duration', 'Start Period', 'Power Limit']} keys={['start', 'duration', 'start_period', 'limit']} data={schedule} />

            <div className={classes.ButtonContainer}>
                <div className="btn-secondary" onClick={setOpen}>
                    Close
                </div>
            </div>
        </div>
    );
};

export default ProfileModal;
